import React from 'react';
import * as firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

firebase.initializeApp(config);

const firebaseContext = React.createContext({
  firebase,
  auth: firebase.auth,
  analytics: firebase.analytics(),
  database: firebase.database(),
  firestore: firebase.firestore(),
  functions: firebase.functions(),
  storage: firebase.storage(),
});

const firebaseAuth = firebase.auth;
const useFirebase = () => React.useContext(firebaseContext);

export default useFirebase;
export { firebaseAuth };
